import React, { useEffect, useRef, useState } from "react";
import Header from "../../../Common/Header";
import { Card, Button, Breadcrumb, Affix, Form } from "antd";
import { isMobileView } from "../../../Common/AppHelper";
import { Link, useNavigate, useParams } from "react-router-dom";
import { postData, getData } from "../../../../apiServices/common";
import ReconciliationForm from "./ReconciliationForm";
import { BOOKING_CARTON_EDIT } from "../../../../apiServices/API_ENDPOINTS";

export default function EditCartonBooking(props) {
  const { id } = useParams();

  const { width, viewMode } = props;
  const propertyFormRef = useRef(null);
  const [reconciliationInfo, setReconciliationInfo] = useState();
  const [form] = Form.useForm();

  const navigate = useNavigate();
  const discartForm = () => {
    navigate("/carton-booking");
  };

  const updateReconciliation = () => {
    form.submit();
  };

  const getReconciliationInfo = async () => {
    if (!id) return;
    const edit_url = BOOKING_CARTON_EDIT(id);
    const response = await getData(edit_url);

    if (response && response?.data?.code === 200) {
      setReconciliationInfo(response?.data?.data);
    }
  };

  useEffect(() => {
    getReconciliationInfo();
  }, [id]);

  return (
    <>
      <Affix offsetTop={0}>
        <Card className="p-fixed" style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}>
          <Header
            title="Update Carton & Poly Booking"
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Affix offsetTop={20}>
                <Button size="small" key={1} danger onClick={() => discartForm()}>
                  Discard
                </Button>
              </Affix>,
              <Affix offsetTop={20}>
                <Button size="small" key={2} type="primary" disabled={viewMode} onClick={() => updateReconciliation()}>
                  Update
                </Button>
              </Affix>,
            ]}
          />
        </Card>
      </Affix>

      <ReconciliationForm
        ref={propertyFormRef}
        reconciliationInfo={reconciliationInfo}
        reconciliationId={id}
        form={form}
        isEdit={true}
        viewMode={viewMode}
        discartForm={discartForm}
        onSupportingMaterialAdded={getReconciliationInfo}
      />
    </>
  );
}
